export default {
  getCanningProcess: (state) => state.canningProcess,
};
